import { useCallback } from "react";

import { RULES_BUSINESS_TYPE_LABELS } from "src/constants/rules";
import { useT } from "src/internationalization";
import { RuleBusinessType } from "src/types/rule";

export const useGetRuleBusinessTypeLabel = () => {
  const t = useT();

  const getRuleBusinessTypeLabel = useCallback(
    (businessType: RuleBusinessType) => {
      return t(RULES_BUSINESS_TYPE_LABELS[businessType]);
    },
    [t]
  );

  return getRuleBusinessTypeLabel;
};
